import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { keyBy, get } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CheckpointsTimeline from 'components/Account/Transactions/TransactionDetails/CheckpointsTimeline';
import helpers from 'utils/helpers';

import ImagePlane from 'assets/images/plane-black.svg';
import { getTrackingRequest } from 'ducks/shipments';

import countries from 'data/countries';

class TransactionDetails extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log(this.props.shipment);
  }

  componentDidMount() {
    this.props.getTrackingRequest({
      trackingNumber: this.props.match.params.trackingNumber
    });
  }

  render() {
    const countriesData = keyBy(this.props.countries, 'alpha-2');
    const shipment = this.props.shipment || false;

    if (!shipment && this.props.getTrackingSuccess) {
      this.props.history.push(
        `${process.env.PUBLIC_URL}/create-shipment/quotation`
      );

      return null;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {`${this.props.t('transactions.my_items')}`}
            {shipment.trackingNumber
              ? `(TRK# ${shipment.trackingNumber})`
              : ''}{' '}
            | Spaceship
          </title>
        </Helmet>
        {shipment ? (
          <React.Fragment>
            <div
              style={{
                backgroundColor: '#f5f5f5',
                margin: '0 auto',
                width: '100%',
                height: '100%',
                maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
              }}>
              <div
                style={{
                  paddingBottom: '60px',
                  display: this.props.trackingLoading ? 'block' : 'none'
                }}>
                <div
                  style={{
                    padding: '20px 0',
                    textAlign: 'center',
                    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#fff',
                    position: 'relative'
                  }}>
                  <div
                    style={{
                      fontSize: '12px',
                      position: 'absolute',
                      top: '0px',
                      left: '0px',
                      padding: '20px 15px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      this.props.history.push(
                        `${process.env.PUBLIC_URL}/create-shipment/quotation`
                      );
                    }}>
                    <FontAwesomeIcon icon="angle-left" />
                  </div>
                  <div style={{ fontSize: '12px' }}>
                    <div
                      style={{ display: 'inline-block', paddingRight: '10px' }}>
                      {helpers.responsiveImage(
                        helpers.getCarrierImage(
                          shipment.carrierService.carrier
                        ),
                        helpers.getCarrierText(shipment.carrierService.carrier),
                        helpers.getCarrierImageWidth(
                          shipment.carrierService.carrier,
                          0.7
                        )
                      )}
                    </div>
                    <span style={{ verticalAlign: 'middle' }}>
                      {get(shipment.carrierService.name, this.props.t('key'))}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      padding: '7px 0 5px'
                    }}>
                    {get(
                      countriesData[shipment.fromAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                    <img
                      src={ImagePlane}
                      style={{
                        width: '31.3px',
                        paddingBottom: '2px',
                        margin: '0 6px'
                      }}
                      alt=""
                    />
                    {get(
                      countriesData[shipment.toAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                  </div>
                  <div>
                    <div style={{ fontSize: '12px' }}>
                      {'TRK# '} {shipment.trackingNumber}
                    </div>
                  </div>
                </div>
                <div style={{ paddingTop: '6px' }}>
                  {shipment.tracking ? (
                    <div style={{ padding: '40px 15px 10px' }}>
                      <CheckpointsTimeline
                        t={this.props.t}
                        checkpoints={shipment.tracking.checkpoints}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getTrackingRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    authRequestSuccess: state.auth.authRequestSuccess,
    uiLoading: !!state.users.loading,
    trackingLoading: state.shipments.trackingLoading || true,
    getTrackingSuccess: state.shipments.getTrackingSuccess || false,
    shipment: state.shipments.shipment || false,
    countries: state.shipments.countries || countries
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(TransactionDetails))
);
